"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUrl = exports.getSessionProperty = exports.merge = exports.removeLocalStorage = exports.getLocalStorage = exports.setLocalStorageJSON = exports.setLocalStorage = exports.documentElementByClass = exports.documentElementByIdNode = void 0;
var constants = require("./constants");
function documentElementByIdNode(elementID) {
    return document.getElementById(elementID);
}
exports.documentElementByIdNode = documentElementByIdNode;
function documentElementByClass(elementClass) {
    return document.getElementsByClassName(elementClass)[0];
}
exports.documentElementByClass = documentElementByClass;
function setLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
exports.setLocalStorage = setLocalStorage;
/**
 * @function setLocalStorageJSON
 * @description guarda en localStorage un JSON
 * @param key
 * @param value
 */
function setLocalStorageJSON(key, value) {
    value = JSON.stringify(value);
    setLocalStorage(key, value);
}
exports.setLocalStorageJSON = setLocalStorageJSON;
function getLocalStorage(key) {
    return localStorage.getItem(key);
}
exports.getLocalStorage = getLocalStorage;
function removeLocalStorage(key) {
    localStorage.removeItem(key);
}
exports.removeLocalStorage = removeLocalStorage;
/**
 * Merge a `source` object to a `target` recursively
 *
 */
function merge(target, source) {
    // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        if (source[key] instanceof Object)
            Object.assign(source[key], merge(target[key], source[key]));
    }
    // Join `target` and modified `source`
    Object.assign(target || {}, source);
    return target;
}
exports.merge = merge;
/**
 * @function getSessionProperty
 * @description Obtiene la sesión del chat mientras se está en la encuesta de caritas
 * @param value
 * @return el estado del chat o el objeto con toda la información del chat
 */
function getSessionProperty(value) {
    var _a;
    var five9ChatSession = getLocalStorage(constants.LOCAL_STORAGE_FIVE9_ITEM) || "{}";
    return (_a = JSON.parse(five9ChatSession)[value]) !== null && _a !== void 0 ? _a : null;
}
exports.getSessionProperty = getSessionProperty;
/**
 * @function validateUrl
 * @description Valida dentro de un array de posibles rutas si la del usuario esta incluida
 * @return Un boolean de acuerdo al resultado de la validación
 */
function validateUrl(urlsAllowed) {
    var CURRENT_URL = window.location.href;
    return urlsAllowed.find(function (_url) { return CURRENT_URL.includes(_url); }) ? true : false;
}
exports.validateUrl = validateUrl;
//# sourceMappingURL=utils.js.map